import React, { memo, useContext } from 'react'

import { useLocation } from 'Pods/Shared/ContextBasedRouter'
import { parseRunIdFromPathname } from 'Pods/ThreeDStudio/Hooks/parseRunIdFromPathname'
import useIsWatchingGeneratingRun from 'Pods/ThreeDStudio/Hooks/useIsWatchingGeneratingRun'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

import InitialBannerState from './Components/InitialBannerState/InitialBannerState'
import LoadingBannerState from './Components/LoadingBannerState/LoadingBannerState'
import UploadingBannerState from './Components/UploadingBannerState/UploadingBannerState'

function Banner() {
  // Only the run named by the URL replaces the starting screen with its progress state:
  // a run in flight elsewhere leaves bare /ai alone. See useIsWatchingGeneratingRun.
  const isWatchingGeneratingRun = useIsWatchingGeneratingRun()
  const isModelUploading = useThreeDStudioStore(state => state.ui?.isModelUploading)
  const location = useLocation()
  const isLoadingModelFromUrl = parseRunIdFromPathname(location?.pathname ?? '') != null
  const { extractingCoreStyles } = useContext(ThreeDStudioPageContext)

  if (extractingCoreStyles) {
    return (
      <div className="extraction-versions-wrapper">
        <InitialBannerState />
        <LoadingBannerState />
      </div>
    )
  }

  // Uploading wins over a model-from-URL load: it reflects the user's most
  // recent action, and the two can briefly overlap before navigate('/ai').
  if (isModelUploading) {
    return <UploadingBannerState />
  }

  if (isWatchingGeneratingRun || isLoadingModelFromUrl) {
    return <LoadingBannerState />
  }

  return <InitialBannerState />
}

export default memo(Banner)
